import { useEffect } from "react";
import { authController } from '@reedexpo/authorization-component-ui';

export const PostLogout = () => {

  useEffect(() => {
    const config = window['authSettings'];

    authController.initialize(config);
    authController.handleLogoutCallback(window.location.search.substring(1));
  }, []);

  return (
    <div/>
  );
};
